import type { FeeReferenceData, RefLabel } from '../services/productFees';

export const ROUTABLE_PAYER_PAIRS: readonly (readonly [string, string])[] = [
    ['Customer', 'MotorPlan'],
    ['Customer', 'Dealer'],
    ['Customer', 'ThirdParty'],
    ['MotorPlan', 'Dealer'],
    ['MotorPlan', 'ThirdParty'],
    ['Dealer', 'MotorPlan'],
];

export function isRoutablePayerPair(paidByCode: string, paidToCode: string): boolean {
    return ROUTABLE_PAYER_PAIRS.some(([by, to]) => by === paidByCode && to === paidToCode);
}

export interface DefaultPayerPair {
    paidById: string;
    paidToId: string;
}

export function defaultPairOfTransactionType(
    transactionTypeId: string | undefined,
    transactionTypes: FeeReferenceData['transaction_types'],
): DefaultPayerPair | null {
    const type = transactionTypes.find((candidate) => candidate.id === transactionTypeId);

    if (!type?.paid_by_id || !type.paid_to_id) return null;

    return { paidById: type.paid_by_id, paidToId: type.paid_to_id };
}

export function targetName(targets: RefLabel[], id: string | undefined): string {
    return targets.find((target) => target.id === id)?.name ?? '—';
}
